export default __webpack_public_path__ + "static/bulbBlack-cd5cc20ec05a6589fd1207ba087046ac.svg";